export const BLOGS_DATA = [
  {
    id: "1",
    blogId: "check-the-safest-and-surest-way-to-check-loose-dropping-in-poultry",
    title: "CHECK® - THE SAFEST AND SUREST WAY TO CHECK LOOSE DROPPING IN POULTRY",
    intro: `Loose droppings, or diarrhoea, are among the most common and concerning issues in poultry farming.
    They not only affect bird comfort but also reduce productivity, increase mortality risk, and raise treatment costs.
    Diarrhea is not a disease itself; it is a symptom that can arise due to several reasons:`,

    reasons: [
      {
        label: "Nutritional factors",
        text: "sudden changes in diet, poor-quality feed, or an imbalance in nutrients.",
      },
      {
        label: "Infectious causes",
        text: "bacterial, viral, or parasitic infections such as E. coli, Salmonella, or coccidiosis.",
      },
      {
        label: "Antibiotic-induced imbalance",
        text: "prolonged or excessive use of antibiotics disturbs the natural gut flora.",
      },
      {
        label: "Environmental stress",
        text: "poor hygiene, contaminated water, and over-specialized extreme temperatures.",
      },
      {
        label: "Hormonal or metabolic issues",
        text: "relatively rare but require specialized veterinary care.",
      },
    ],

    subHeading: "Why Antibiotics Are Not the Best Solution",

    antibioticsIntro: `For decades, antibiotics have been the go-to treatment for controlling diarrhea. While they may
suppress harmful bacteria temporarily, their disadvantages outweigh the benefits:`,

    antibioticPoints: [
      "Kill both harmful and beneficial bacteria, thereby disrupting the natural balance of the gut.",
      "Reduce feed intake and growth due to stress on the digestive system.",
      "Weaken long-term resistance, leaving birds prone to repeat infections.",
      "Raise concerns about residues in meat and eggs, which impact food safety and consumer trust.",
    ],

    conclusion: `Given the drawbacks of antibiotics, there is a pressing need for safe, fast-acting, and antibiotic-free alternatives.
This is not just a preference, but a necessity for the health and productivity of your flock.`,
    
    highlightone: `CHECK® is a specially formulated probiotics-based, natural, safe product that provides
        rapid and reliable control of diarrhoea in poultry without side effects in less than 6 hours.
        It helps restore gut health and flock productivity, regardless of the cause, whether infectious, nutritional,
        or antibiotic induced (except in cases involving hormonal imbalance, which is necessary for growth).`,
    

    highlighttwo: {
      intro: `CHECK® is a specially formulated probiotics-based, natural, safe product that provides rapid and reliable control of diarrhoea in poultry without side effects in less than 6 hours. It helps restore gut health and flock productivity, regardless of the cause, whether infectious, nutritional, or antibiotic induced (except in cases involving hormonal imbalance, which is necessary for growth).`,
      multiTargetApproach: [
        "Restoring gut microbial balance with beneficial probiotics.",
        "Neutralising bacterial toxins and preventing further intestinal damage.",
        "Flushing out harmful pathogens through binding action.",
        "Activating the immune system to resist infections and improve resilience.",
        "Providing quick energy to support faster recovery.",
      ],
      combinedAction: `This combined action ensures that diarrhoea - whether due to infection, feed imbalance, or antibiotic side effects - is controlled safely, rapidly, and without the drawbacks of antibiotics.`,
      benefits: [
        "Fast action without negative side effects.",
        "Improves digestion and feed conversion ratio (FCR).",
        "Reduces inflammation and pathogen load.",
        "Protects the gastrointestinal and respiratory tracts.",
        "Boosts non-specific immunity for long-term resistance.",
        "Safe for preventive use at regular intervals.",
        "100% free from antibiotics and chemical residues.",
      ],
      dosage: [
        "Dosage: 200g of CHECK® for 5000 chicks/broilers/layers/breeders.",
        "Administer in the first water or feed of the day at the first sign of loose droppings.",
        "Preferably given through water; if water sanitisers are used, mix them in with the feed instead. Ensure uniform and thorough mixing.",
        "Dosage may be adjusted depending on flock conditions and veterinary advice.",
      ],
      presentation: [
        "200g multilayer food-grade aluminum packs with a duplex carton box and bulk pails available for larger farm use.",
      ],
      conclusion: [
        "Antibiotics can be effective in managing loose droppings; however, they may also harm gut health and decrease productivity. Fortunately, CHECK® offers a natural, safe probiotics formulation, an antibiotic-free solution that is scientifically proven to work quickly. It boosts immunity, reduces mortality, improves dry matter retention, and enhances the overall wellness of your flock. Embrace a healthier approach today."
      ],
    },
  },
  // Add more blogs as needed...
];